module.exports = __webpack_public_path__ + "img/horizontal_6_2_pp2_0.c5c10681.png";